import React, {useCallback, useEffect, useState} from 'react'
import {
  deleteLibelleDemandePiece, editLibelleDemandePiece,
  postLibelleDemandePiece,
} from '../../../../../components/requests'
import {useFormik} from 'formik'
import {toast} from 'react-toastify'
import IconDevis from '../../../../../components/icon/iconDevis'
import {SelectInput} from '../../../../../components/inputs/SelectInput'

const ShopLibelle = (props) => {
  const {
    libelleForm,
    setLibelleForm,
    demandeId,
    libelleList,
    getAllLibelleDemande,
    spinnerLibelleDiplay,
    showForm,
    setShowForm,
    totalLibelle,
    panier,
    setHasLibelleChanged,
    showEditForm,
    setShowEditForm
  } = props

  const [spinnerDelete, setSpinnerDelete] = useState<Record<string, boolean>>({})
  const [spinnerAdd, setSpinnerAdd] = useState<boolean>(false)
  const [spinnerEdit, setSpinnerEdit] = useState<boolean>(false)
  const [codeError, setCodeError] = useState<boolean>(false)
  const [descriError, setDescriError] = useState<boolean>(false)
  const [piecesOption, setPiecesOption] = useState<{label: string, value: string | number | null}[]>([{
    label: 'Associer à une pièce',
    value: null,
  }])
  const [disableEdit, setDisableEdit] = useState<boolean>(false)

  const submitLibelleDemande = async (libelle) => {
    setSpinnerAdd(true)
    try {
      const res = await postLibelleDemandePiece(libelle, demandeId)
      if (res?.status === 200) {
        toast.success('Libellé ajouté avec succès')

        getAllLibelleDemande(true)
        return true
      }
      return false
    } catch (ex) {
      toast.error("Erreur lors de l'ajout")
    } finally {
      setSpinnerAdd(false)
    }
  }

  const submitLibelleDemandeEdition = async (libelle) => {
    setSpinnerEdit(true)
    try {
      const res = await editLibelleDemandePiece(libelle)

      if (res?.status === 200) {
        getAllLibelleDemande(true)
        setShowEditForm(null)
        return true
      }
      return false

    } catch (e) {
      console.error('Erreur lors de la modification')
    } finally {
      setSpinnerEdit(false)
    }
  }

  const handleLibelleDelete = async (id) => {
    setSpinnerDelete((prev) => ({...prev, [String(id)]: true}))
    try {
      const res = await deleteLibelleDemandePiece(id)

      if (res?.status === 200) {
        toast.success('Libellé supprimé avec succès')

        getAllLibelleDemande(true)
      }
    } catch (ex) {
      toast.error('Erreur lors de la suppresion')
      console.error(ex)
    } finally {
      setSpinnerDelete((prev) => ({...prev, [String(id)]: false}))
    }
  }

  useEffect(() => {
    if (libelleForm?.code == '') {
      formik.setFieldValue('libelle', '')
    } else {
      formik.setFieldValue('libelle', libelleForm.code)
      formik.setFieldValue('id', libelleForm.id)
    }

    if (libelleForm?.commentaire == '') {
      formik.setFieldValue('commentaire', '')
    } else {
      formik.setFieldValue('commentaire', libelleForm.commentaire)
    }

    if (libelleForm?.prixUnitaire == '') {
      formik.setFieldValue('prixUnitaire', '')
    } else {
      formik.setFieldValue('prixUnitaire', libelleForm.prixUnitaire)
    }

    if (libelleForm?.quantite == '') {
      formik.setFieldValue('quantite', '')
    } else {
      formik.setFieldValue('quantite', libelleForm.quantite)
    }
  }, [libelleForm])

  const parsePrice = (value: string): number => {
    return Number(value.replace(',', '.'))
  }

  const formik = useFormik({
    initialValues: {
      id: libelleForm.id,
      libelle: libelleForm.libelle,
      commentaire: libelleForm.commentaire,
      prixUnitaire: '',
      quantite: '',
      idTypeLibelleDemande: libelleForm.id,
      piece: null,
    },
    onSubmit: async (values: any, {resetForm}) => {
      if (values.libelle === '') {
        setCodeError(true)
      } else {
        setCodeError(false)
      }

      if (values.commentaire === '') {
        setDescriError(true)
      } else {
        setDescriError(false)
      }

      const libelleValue = {
        id: values.id,
        libelle: values.libelle,
        commentaire: values.commentaire,
        prixUnitaire: parsePrice(values.prixUnitaire),
        quantite: values.quantite,
        idTypeLibelleDemande: values.id,
        piece: values.piece,
      }
      if (values.libelle !== '' && values.commentaire !== '') {
        const success = await submitLibelleDemande(libelleValue)

        if (success) {
          const valuesInitialized = {
            id: '',
            libelle: '',
            commentaire: '',
            prixUnitaire: '',
            quantite: '',
            idTypeLibelleDemande: '',
            piece: null,
          }
          resetForm({
            values: valuesInitialized,
          })
          setLibelleForm(valuesInitialized)
          setShowForm(false)
          setCodeError(false)
          setDescriError(false)
        }
      }
    },
  })

  const renderTotal = (libelle) => {
    const calcul = libelle?.quantite * libelle?.prixUnitaire
    return <span>Total: {calcul.toFixed(2)} € </span>
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let val = e.target.value
    // Autorise chiffres, virgule et point
    if (!/^[0-9.,]*$/.test(val)) {
      formik.setFieldError('prixUnitaire', 'Caractères non autorisés')
      return // on ignore la saisie
    }

    // Une seule virgule ou point
    const commas = (val.match(/[,.]/g) || []).length
    if (commas > 1) {
      formik.setFieldError('prixUnitaire', 'Format invalide')
      return
    }

    formik.setFieldError('prixUnitaire', undefined)
    formik.setFieldValue('prixUnitaire', val)
  }

  // Annulation saisie formulaire libelle
  const handleCancelForm = () => {
    setShowForm(false)
    setCodeError(false)
    setDescriError(false)
  }

  useEffect(() => {
    formatOptionsAssoc()
  }, [panier])

  // Pour formater les options pour l'association libellé - pièces
  const formatOptionsAssoc = useCallback(() => {
    const transformedData = panier.map((item) => {
        let piece = item?.nomTypePieceProposee ?? item.nomTypePieceHN ?? ''
        let vehicle = '['+ item?.marque+' - '+ item?.modele +']'
        return {
          value: item.idPiecePropose,
          label: piece +' '+vehicle,
        }
      }
    )
    const defaultOp = {
      label: 'Associer à une pièce',
      value: null,
    }
    setPiecesOption([defaultOp, ...transformedData])
  }, [panier])

  const handleShowEditForm = (libelle) => {
    formik.setValues({
      id: libelle.id,
      code: libelle?.libelle,
      piece: libelle.clientDemandePieceProposee?.id ?? null,
      libelle: libelle.libelle ?? '',
      quantite: libelle.quantite ?? 0,
      commentaire: libelle.commentaire ?? '',
      prixUnitaire: libelle.prixUnitaire ?? 0,
    })

    setLibelleForm({
      id: libelle.id,
      code: libelle?.libelle,
      piece: libelle.clientDemandePieceProposee?.id ?? null,
      libelle: libelle.libelle ?? '',
      quantite: libelle.quantite ?? 0,
      commentaire: libelle.commentaire ?? '',
      prixUnitaire: libelle.prixUnitaire ?? 0,
    })
    setShowForm(false)
    setShowEditForm(libelle?.id)
  }

  const handleEditLibelleDemande = async (e: React.FormEvent, libelle, idLibelle) => {
    e.preventDefault()

    const mergedLibelle = {
      ...libelle,
      id: idLibelle,
    }

    submitLibelleDemandeEdition(mergedLibelle)
  }

  const handleEditCancel = (labelDefaultValue) => {
    formik.setValues({
      id: labelDefaultValue.id,
      code: labelDefaultValue?.libelle,
      piece: labelDefaultValue.clientDemandePieceProposee?.id ?? null,
      libelle: labelDefaultValue.libelle ?? '',
      quantite: labelDefaultValue.quantite ?? 0,
      commentaire: labelDefaultValue.commentaire ?? '',
      prixUnitaire: labelDefaultValue.prixUnitaire ?? 0,
    })
    setShowEditForm(null)
  }

  useEffect(function disableSubmitEditButton(){
    const prixUnitaireModifie =
      !(
        (formik.values.prixUnitaire === 0 || formik.values.prixUnitaire === '') &&
        (libelleForm.prixUnitaire === 0 || libelleForm.prixUnitaire === '')
      ) && formik.values.prixUnitaire !== libelleForm.prixUnitaire

    const quantiteModifie =
      !(
        (formik.values.quantite === 0 || formik.values.quantite === '') &&
        (libelleForm.quantite === 0 || libelleForm.quantite === '')
      ) && formik.values.quantite !== libelleForm.quantite

    if (
      formik.values.libelle !== libelleForm.libelle ||
      prixUnitaireModifie ||
      quantiteModifie ||
      String(formik.values.piece) !== String(libelleForm.piece) ||
      formik.values.commentaire !== libelleForm.commentaire
    ) {
      setDisableEdit(false);
    } else {
      setDisableEdit(true);
    }
  }, [libelleForm, formik])

  return (
    <div className='my-6'>
      {/*Formulaire d'insertion de devise*/}
      {showForm && (
        <form className='mb-6' onSubmit={formik.handleSubmit}>
          <div className='d-flex justify-content-center align-items-center gap-3 mb-3'>
            <input
              className={`form-control ${codeError && 'border border-danger is-invalid'}`}
              type='text'
              placeholder='Code'
              {...formik.getFieldProps('libelle')}
            />
            {libelleForm?.code !== 'PORTP' && (
              <SelectInput
                fieldName={'piece'}
                inputClassName={'form-select form-select-solid form-select-lg fw-bold'}
                options={piecesOption}
                formik={formik}
              />
            )}
            {libelleForm?.code === 'PORTP' && (
              <>
                <input
                  className='form-control'
                  type='number'
                  placeholder='Quantité'
                  min={0}
                  {...formik.getFieldProps('quantite')}
                />
                <input
                  className={`form-control ${
                    formik.errors.prixUnitaire ? 'border border-danger is-invalid' : ''
                  }`}
                  type='text'
                  placeholder='Prix unitaire'
                  min={0}
                  {...formik.getFieldProps('prixUnitaire')}
                  onChange={handleChange}
                  onBlur={() => formik.setFieldTouched('prixUnitaire', true)}
                />
              </>
            )}
          </div>
          <div className='mb-3'>
            <textarea
              className={`form-control ${descriError && 'border border-danger is-invalid'}`}
              placeholder='Désignation...'
              cols={15}
              rows={5}
              {...formik.getFieldProps('commentaire')}
            ></textarea>
          </div>
          <div className='d-flex gap-3'>
            <button
              className='btn btn-sm btn-light-primary align-items-center'
              onClick={() => setHasLibelleChanged(true)}
              type='submit'
            >
              Ajouter{' '}
              {spinnerAdd && (
                <span className='spinner-border spinner-border-sm align-middle ms-2 w-15px h-15px'></span>
              )}
            </button>
            <button
              className='btn btn-sm btn-light-info'
              type='button'
              onClick={() => handleCancelForm()}
            >
              Annuler
            </button>
          </div>
        </form>
      )}

      {/*Liste des devises*/}
      {spinnerLibelleDiplay ? (
        <div className='d-flex flex-column align-items-center justify-content-center h-100 border border-muted p-9 rounded-1 my-3'>
          <span className='spinner-border spinner-border-sm align-middle ms-2 w-30px h-30px'></span>
        </div>
      ) : (
        <div className='overflow-y-scroll mh-350px rounded-1 border border-muted p-6'>
          {libelleList.length > 0 ? (
            libelleList?.map((item, index) => {
              const cdpp = item?.clientDemandePieceProposee
              const pce = cdpp?.pieceEntre
                ? cdpp.pieceEntre.piece?.typePiece?.nom
                : cdpp?.typePiecePOT?.nomPiece
              return (
                <>
                  {showEditForm === item?.id ? (
                    <form
                      className='mb-6'
                      onSubmit={(e) => handleEditLibelleDemande(e, formik.values, item?.id)}
                    >
                      <div className='d-flex justify-content-center align-items-center gap-3 mb-3'>
                        <input
                          className={`form-control ${
                            codeError && 'border border-danger is-invalid'
                          }`}
                          type='text'
                          placeholder='Code'
                          {...formik.getFieldProps('libelle')}
                        />
                        {libelleForm?.code !== 'PORTP' && (
                          <SelectInput
                            fieldName={'piece'}
                            inputClassName={'form-select form-select-solid form-select-lg fw-bold'}
                            options={piecesOption}
                            formik={formik}
                            disabled={true}
                          />
                        )}
                        {libelleForm?.code === 'PORTP' && (
                          <>
                            <input
                              className='form-control'
                              type='number'
                              placeholder='Quantité'
                              min={0}
                              {...formik.getFieldProps('quantite')}
                            />
                            <input
                              className={`form-control ${
                                formik.errors.prixUnitaire ? 'border border-danger is-invalid' : ''
                              }`}
                              type='text'
                              placeholder='Prix unitaire'
                              min={0}
                              {...formik.getFieldProps('prixUnitaire')}
                              onChange={handleChange}
                              onBlur={() => formik.setFieldTouched('prixUnitaire', true)}
                            />
                          </>
                        )}
                      </div>
                      <div className='mb-3'>
                        <textarea
                          className={`form-control ${
                            descriError && 'border border-danger is-invalid'
                          }`}
                          placeholder='Désignation...'
                          cols={15}
                          rows={5}
                          {...formik.getFieldProps('commentaire')}
                        ></textarea>
                      </div>
                      <div className='d-flex gap-3'>
                        <button
                          className='btn btn-sm btn-light-primary align-items-center'
                          type='submit'
                          disabled={disableEdit}
                        >
                          Modifier{' '}
                          {spinnerEdit && (
                            <span className='spinner-border spinner-border-sm align-middle ms-2 w-15px h-15px'></span>
                          )}
                        </button>
                        <button
                          className='btn btn-sm btn-light-info'
                          type='button'
                          onClick={() => handleEditCancel(item)}
                        >
                          Annuler
                        </button>
                      </div>
                    </form>
                  ) : (
                    <div className='border border-1 rounded rounded-1 p-3 mb-3'>
                      <div className='d-flex justify-content-between'>
                        <div>
                          <span className='badge badge-sm badge-info'>{item?.libelle}</span>
                          {pce && <span className='badge badge-sm badge-primary ms-4'>{pce}</span>}
                        </div>
                        <div>
                          <div
                            className='btn btn-icon btn-bg-light btn-sm'
                            onClick={() => handleShowEditForm(item)}
                          >
                            <i className='ki-duotone ki-pencil fs-2x'>
                              <span className='path1' />
                              <span className='path2' />
                            </i>
                          </div>
                          <div
                            className='btn btn-icon btn-bg-light btn-sm ms-2'
                            onClick={() => {
                              handleLibelleDelete(item.id)
                              setHasLibelleChanged(true)
                            }}
                          >
                            {spinnerDelete[String(item.id)] ? (
                              <span className='spinner-border spinner-border-sm align-middle w-15px h-15px text-muted'></span>
                            ) : (
                              <i className='ki-duotone ki-trash fs-2x text-danger'>
                                <span className='path1'></span>
                                <span className='path2'></span>
                                <span className='path3'></span>
                                <span className='path4'></span>
                                <span className='path5'></span>
                              </i>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className={'mb-3'}>{item?.commentaire}</div>
                      {item?.typeLibelleDemande?.code === 'Frais port' && (
                        <div>
                          <div className='d-flex justify-content-between'>
                            <div className='d-flex gap-3'>
                              <div className='d-flex gap-3 align-items-center'>
                                <label>Qte:</label>
                                <input
                                  className='form-control form-control-sm '
                                  value={item?.quantite}
                                  disabled
                                />
                              </div>
                              <div className='d-flex gap-3 align-items-center'>
                                <label>PU:</label>
                                <input
                                  className='form-control form-control-sm disabled'
                                  value={item?.prixUnitaire}
                                  disabled
                                />{' '}
                                €
                              </div>
                            </div>
                            {renderTotal(item)}
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </>
              )
            })
          ) : (
            <div className='d-flex flex-column align-items-center justify-content-center h-100'>
              <IconDevis size={90} />
              <p className='text-muted'>Aucun libellé trouvé lié à la demande</p>
            </div>
          )}
        </div>
      )}
      {libelleList.length > 0 && (
        <>
          <div className={'d-flex justify-content-center align-items-baseline mt-3 fw-semibold'}>
            Total:
            <span className='fs-4 mx-3'>{totalLibelle.toFixed(2)}</span>
          </div>
        </>
      )}
    </div>
  )
}

export default ShopLibelle
